import { Component, inject, input } from '@angular/core';
import { StoryblokDirective } from '../../../directives/storyblok.directive';
import { 
  RdsButtonModule,
  RdsCardModule,
  RdsIconsModule,
} from '@rds/angular-components';
import { Router, RouterLink } from '@angular/router';

@Component({
  selector: 'inexp-visual-card',
  imports: [
      StoryblokDirective,
      RouterLink,
      RdsButtonModule,
      RdsIconsModule,
      RdsCardModule,
  ],
  templateUrl: './visual-card.component.html',
  styleUrl: './visual-card.component.scss'
})
export class VisualCardComponent {
  router = inject(Router);
  _editable = input<string>();
  _uid = input<string>();
  component = input<string>();

  title = input<string>();
  overline = input<string>();
  label = input<string>();
  description = input<string>();
  image = input<any>();
  buttonTitle = input<string>();
  buttonLink = input<string>();

  navigate() {
    this.router.navigate([this.buttonLink()]);
  }

}
